import { render, staticRenderFns } from "./talentCardList.vue?vue&type=template&id=37d61294&scoped=true&"
import script from "./talentCardList.vue?vue&type=script&lang=js&"
export * from "./talentCardList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d61294",
  null
  
)

export default component.exports